import React from 'react';
const ProblemSection = () => {
  return <section className="py-20 px-6 md:px-12 bg-white" data-id="element-203">
      <div className="max-w-5xl mx-auto text-center mb-8" data-id="element-204">
        <h2 className="text-3xl md:text-4xl font-bold text-teal-900 mb-6" data-id="element-205">
          You're Doing Incredible Work.
        </h2>
        <p className="text-xl text-gray-700 mb-8" data-id="element-206">
          But you're tired of trying to carry it all on your own.
        </p>
        <div className="max-w-md mx-auto mb-16" data-id="element-207">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gqT1FhLX17Jpvj1Yw3VnLc/do-i-actually-need-therapy-clearing-up-some-misconceptions-01.jpg" alt="Therapy session illustration" className="rounded-lg shadow-md w-full h-auto" data-id="element-208" />
        </div>
      </div>
      <div className="max-w-6xl mx-auto" data-id="element-209">
        <div className="bg-teal-50 rounded-xl p-8 md:p-12" data-id="element-210">
          <p className="text-lg md:text-xl text-teal-800 mb-8" data-id="element-211">
            You give your clients everything:
          </p>
          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-212">
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-213">
              <h3 className="text-xl font-semibold text-teal-900 mb-2" data-id="element-214">
                Your sessions
              </h3>
              <p className="text-gray-700" data-id="element-215">
                Dedicated time and energy focused on their healing journey.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-216">
              <h3 className="text-xl font-semibold text-teal-900 mb-2" data-id="element-217">
                Your guidance
              </h3>
              <p className="text-gray-700" data-id="element-218">
                Professional expertise and personalized direction.
              </p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-sm" data-id="element-219">
              <h3 className="text-xl font-semibold text-teal-900 mb-2" data-id="element-220">
                Your presence
              </h3>
              <p className="text-gray-700" data-id="element-221">
                Full attention and compassionate support.
              </p>
            </div>
          </div>
          <p className="text-lg md:text-xl text-teal-800 mb-8" data-id="element-222">
            And still, they come back saying:
          </p>
          <div className="space-y-4 mb-10" data-id="element-223">
            <div className="bg-white p-5 rounded-lg shadow-sm border-l-4 border-teal-600" data-id="element-224">
              <p className="italic text-gray-700" data-id="element-225">
                "I feel better during our work, but it doesn't last."
              </p>
            </div>
            <div className="bg-white p-5 rounded-lg shadow-sm border-l-4 border-teal-600" data-id="element-226">
              <p className="italic text-gray-700" data-id="element-227">
                "I'm trying the tools, but nothing's sticking."
              </p>
            </div>
            <div className="bg-white p-5 rounded-lg shadow-sm border-l-4 border-teal-600" data-id="element-228">
              <p className="italic text-gray-700" data-id="element-229">
                "I know what to do—but I can't seem to do it."
              </p>
            </div>
          </div>
          <div className="text-center" data-id="element-230">
            <p className="text-lg font-medium text-gray-800 mb-3" data-id="element-231">
              It's not you. It's not them. It's the missing layer in most
              healing work today:
            </p>
            <p className="text-xl md:text-2xl font-bold text-teal-900" data-id="element-232">
              Daily, body-based nervous system retraining tools that gently
              rewire patterns between sessions.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default ProblemSection;